module.exports = __webpack_public_path__ + "fonts/nanumgothic-regular-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Nanum_Gothic/nanumgothic-regular-webfont.woff2
// module id = 3440
// module chunks = 0